import { HostingTypes } from '../../SearchFilters/Filters/HostingFilters';
const sortOptionIndexConfig = [{
  key: 'topRated',
  indexSuffix: () => {
    return 'desc_ratings.ratingsScore';
  }
}, {
  key: 'trending',
  indexSuffix: () => {
    return 'desc_distribution.deltaInstalls';
  }
}, {
  key: 'topSelling',
  indexSuffix: filters => {
    const hostingFilter = filters === null || filters === void 0 ? void 0 : filters.hosting;
    if (hostingFilter && hostingFilter.length) {
      switch (hostingFilter[0].value) {
        case HostingTypes.CLOUD:
          return 'desc_sales.recentGrossCloud';
        case HostingTypes.SERVER:
          return 'desc_sales.recentGrossServer';
        case HostingTypes.DATA_CENTER:
          return 'desc_sales.recentGrossDataCenter';
        default:
          return 'desc_sales.recentGrossTotal';
      }
    }
    return 'desc_sales.recentGrossTotal';
  }
}, {
  key: 'newest',
  indexSuffix: () => {
    return 'desc_releaseDate';
  }
}];
export const resolveAlgoliaSortIndexAndFilters = (index, sortKey, filters) => {
  const sortOption = sortOptionIndexConfig.find(option => option.key === sortKey);
  let newIndex = index;
  let sortFilters = {};
  if (sortOption) {
    newIndex = index + "_".concat(sortOption === null || sortOption === void 0 ? void 0 : sortOption.indexSuffix(filters));
    if (sortOption.applyOverrides) {
      sortFilters = sortOption.applyOverrides();
    }
  }
  return {
    transformedAlgoliaIndex: newIndex,
    sortFilters
  };
};